export type NumberOfFlowColumns = 1 | 2 | 3 | 4 | 5 | 6;

const DEFAULT_NB_FLOWS_COLUMNS_WITH_MAP: NumberOfFlowColumns = 2;
const DEFAULT_NB_FLOWS_COLUMNS: NumberOfFlowColumns = 4;
const DEFAULT_NB_MEASURES_COLUMNS = 3;
const DEFAULT_MEASURE_LOAD_BAR_HEIGHT_EM = 0.7;
const DEFAULT_DASHBOARD_MEASURES_FLIGHTS_PANEL_WIDTH = '34vw';
const DEFAULT_MINI_MAP_WIDTH = '50%';
const DEFAULT_HIDE_CHAT_DRAWER = true;
const DEFAULT_HIDE_GLOBAL_MONITORING = false;

export default class AppConstants {
    public static nbFlowsColumnsWithMap: NumberOfFlowColumns = DEFAULT_NB_FLOWS_COLUMNS_WITH_MAP;
    public static nbFlowsColumns: NumberOfFlowColumns = DEFAULT_NB_FLOWS_COLUMNS;
    public static nbMeasuresColumns = DEFAULT_NB_MEASURES_COLUMNS;
    public static measureLoadBarHeightEm = DEFAULT_MEASURE_LOAD_BAR_HEIGHT_EM;
    public static dashboardMeasuresFlightsPanelWidth = DEFAULT_DASHBOARD_MEASURES_FLIGHTS_PANEL_WIDTH;
    public static miniMapWidth = DEFAULT_MINI_MAP_WIDTH;
    public static hideChatDrawer = DEFAULT_HIDE_CHAT_DRAWER;
    public static hideGlobalMonitoring = DEFAULT_HIDE_GLOBAL_MONITORING;
}
